<template>
  <div class="hello">
    <div class="py-4 main-content d-flex flex-column">
      <b-tabs pills fill content-class="mt-3 flex-grow-1" class="main-tabs flex-grow-1 d-flex flex-column" v-model="tabIndex">
        <b-tab title="Design">
          <div v-for="(card, i) in cards" :key="i" class="border-bottom mb-2">
            <b-row>
              <b-col>
                <b-form-group
                  label="Enter your card name"
                  :label-for="'card' + i + '-input1'">
                  <b-form-input :id="'card' + i + '-input1'" v-model="cards[i].name" trim autofocus></b-form-input>
                </b-form-group>
              </b-col>
              <b-col>
                <b-form-group
                  label="Enter your card image (url)"
                  :label-for="'card' + i + '-input2'">
                  <b-form-input :id="'card' + i + '-input2'" v-model="cards[i].img" trim></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
          </div>
          <b-btn @click="addCard">New card</b-btn>
        </b-tab>
        <b-tab title="List">
          <b-form-group
            label="Enter your card list (name, url)"
            label-for="list-input">
            <b-form-textarea id="list-input" v-model="list" trim autofocus rows="5"></b-form-textarea>
          </b-form-group>
          <b-btn @click="addList">Save</b-btn>
        </b-tab>
        <b-tab title="Preview">
          <b-row class="a4-paper h-100" no-gutters>
            <b-col cols="4" class="card border"
              v-for="(card, i) in cards" :key="i">
              <b-img class="position-absolute w-100 h-100 card-image" :src="card.img" />
              <div class="position-absolute h-25 card-caption py-2 px-3 w-100 text-white h3 m-0 text-uppercase font-weight-bold d-flex align-items-center justify-content-center">{{modName(card.name)}}</div>
              <b-btn class="position-absolute delete-button ml-3 mt-3" size="sm" @click="delCard(i)">&times;</b-btn>
            </b-col>
          </b-row>
        </b-tab>
      </b-tabs>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HelloWorld',
  data() {
    return {
      tabIndex: 0,
      cards: [{}],
      list: ''
    }
  },
  methods: {
    addCard() {
      this.cards.push({});
    },
    addList() {
      if (!this.cards[0].name)
        this.cards = [];
      var lines = this.list.split('\n');
      for (var l in lines) {
        var line = lines[l].split(',');
        this.cards.push({name:line[0],img:line[1]});
      }
      this.list = '';
      this.tabIndex = 2;
    },
    modName(name) {
      var newName = '';
      for (var a in name) {
        if (Math.random() > (1/name.length + .2))
          newName += '_ '
        else
          newName += name[a] + ' ';
      }
      return newName;
    },
    delCard(card) {
        this.cards.splice(card, 1);
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
  .card {height:33.3333%;}
  .card-image {left:0;top:0;object-fit:cover;}
  .main-content {height:100vh;}
  .tab-pane {height:100%;}
  .card-caption {background:rgba(0,0,0,.75);bottom:0;}

  @page {
    size: A4;
    margin: 0;
  }
  @media print {
    html, body {
      width: 210mm;
      height: 297mm;
    }
    .a4-paper {width:90% !important;height:90% !important;position:absolute;left:5%;top:5%;}
    .nav-pills,.delete-button {display:none !important;}
    .tab-content {margin:0 !important;}
    .main-content {padding:0 !important;}
    .container {padding:0 !important;max-width:none !important;}
    /* ... the rest of the rules ... */
  }
</style>
